export default class Fix100vh {
    constructor() {
        this.init();
    }

    init() {
        var doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);

        window.addEventListener( 'resize', function() {
            var doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        } );
    }
}